import classNames from 'classnames';
import React from 'react';
import './index.scss';

interface EfSwiperItemProps {
    /**
     * 样式名
     */
    className?: string;
    /**
     * 内容
     */
    children: React.ReactNode;
}

const EfSwiperItem: React.FC<EfSwiperItemProps> = ({ children, className }) => {
    const prefixCls = `ef-scroll-item`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
    });

    return <div className={classes}>{children}</div>;
};

export default EfSwiperItem;
